import useSpriteMapper from 'src/hooks/useSpriteMapper'

type SpriteProps = {
  spriteID: string
  animationDuration?: number
}

const style = {
  position: 'absolute',
  height: '32px',
  width: '32px',
  backgroundColor: 'transparent',
  backgroundSize: '312%',
  imageRendering: 'pixelated'
}

const Sprite = ({ spriteID, animationDuration }: SpriteProps) => {
  const { spriteMap } = useSpriteMapper()

  return (
    <div 
    // @ts-expect-error
      style={ animationDuration === undefined
        ? style
        : {
            ...style,
            animationDuration: `${animationDuration}s`
          }
    } className={`sprite ${spriteMap[spriteID] || spriteID}`}/>
  )
}

export default Sprite
